import {createAction} from '@reduxjs/toolkit';

export const taggedEntitiesStale = createAction('monitoring/taggedEntitiesStale');

type Dispatch = (_action: ReturnType<typeof taggedEntitiesStale>) => unknown;

export const invalidateTaggedEntities = (dispatch: Dispatch) => dispatch(taggedEntitiesStale());
